/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios from 'axios';
import initPolyfills from './polyfills';

export function initGlobals() {
  if (typeof window !== 'undefined') {
    initPolyfills();
    window['r2d2'] = r2d2;
    window['track'] = track;
    window['cookie'] = cookie;
  }
}

function r2d2(in_: InR2D2) {
  const url = cookie('corp_session')
    ? `${
        process.env.NEXT_PUBLIC_CORP_PLATFORM_AUTH_URL || ''
      }/authorization/api/r2d2/`
    : `/api/r2d2/`;

  return axios.post(
    url,
    {
      app: 'NS_Container',
      ua: window?.navigator.userAgent,
      user: in_.user || cookie('user_id'),
      tracker: in_.tracker || cookie('trackerid'),
      ...in_,
      edata: {
        ...(in_.edata || {}),
        anonymousID: webengageAnonymousID(),
        ga_client_id: getGAClientID(),
        is_js: true,
        platform: window?.innerWidth < 480 ? 'mweb' : 'web',
        web_engage: true,
      },
      odata: {
        ...(in_.odata || {}),
        url: window?.location.href,
      },
    },
    {
      withCredentials: true,
    }
  );
}

function track(in_: InGA) {
  // @ts-ignore
  typeof dataLayer !== 'undefined' && dataLayer.push(in_);
}

function getGAClientID() {
  try {
    return window['ga'].getAll()[0].get('clientId');
  } catch {
    return '';
  }
}

function webengageAnonymousID() {
  let aid = cookie('we_aid');
  if (aid !== undefined) return aid;
  try {
    const w: any = window;
    aid = w.webengage.user.getAnonymousId();
    cookie('we_aid', aid);
  } catch {
    aid = '';
  }
  return aid;
}

function cookie(key: string, value?: string) {
  if (typeof document === 'undefined') return;
  if (typeof key === 'string' && typeof value === 'string') {
    document.cookie = `${key}=${value};path=/`;
    return value;
  }
  if (document.cookie.indexOf(`${key}=`) === -1) return;
  return document.cookie.split(`${key}=`)[1].split(';')[0];
}

export const r2d2CustomEvent = `
function getCookie(name) {
  // Split all the cookies into an array
  const cookies = document.cookie.split(";");
  // Loop through the cookies array
  for (let i = 0; i < cookies.length; i++) {
    // Split the cookie into its name and value
    const cookie = cookies[i].trim().split("=");

    // Check if the cookie name matches the provided name
    if (cookie[0] === name) {
      // Return the cookie value
      return decodeURIComponent(cookie[1]);
    }
  }
  // If the cookie is not found, return null
  return null;
}

function isMobile() {
  try {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    // Check if the media query matches
    if (mediaQuery.matches) {
      return "mweb"
    } else {
      return "web"
    }
  } catch(e) {
    return "indeterministic"
  }

}

const platform = isMobile();
const tracker = getCookie("trackerid");
var data = JSON.stringify({
  "app": "NS_Container",
  "ua": navigator.userAgent,
  tracker,
  "ekind": "travel_custom_event_page_loaded",
  "okind": "travel",
  "oid": tracker,
  "edata": {},
  "odata": {
    "url": window.location.href
  }
})

var xhr = new XMLHttpRequest();
xhr.withCredentials = true;

xhr.open("POST", "https://www.acko.com/api/r2d2/");
xhr.setRequestHeader("x-platform", platform);

xhr.send(data);
`;
